import React from "react";
import store from "../store";
import {api, VALID_LANG_CODES} from "./baseFunctions";

export default class LoginPage extends React.Component {
	state = {
		loading: false,
	};

	constructor(){
		super();
		this.login = this.login.bind(this);
	}
	componentDidMount(){
		this.mail.focus();
	}
	login(e){
		if(!this.state.loading)
		{
			e.preventDefault();
			this.setState({
				loading: true,
			});
			api("POST", {"type": "signIn", "username": this.mail.value, "password": this.pass.value}, (d, tag) =>
			{
				this.setState({
					loading: false,
				});
				if(!d.error)
				{
					d.rTag = tag;
					store.dispatch({
						type: 'UPD_LOGIN',
						data: d.data
					});
					if(d.data.lang && VALID_LANG_CODES[d.data.lang])
					{
						store.dispatch({
							type: 'CHANGE_LANG',
							data: d.data.lang
						});
					}
					localStorage.setItem("lastSync", Date.now());

					
					// window.location.reload();
					
				}else{
					alert("Wrong password or username");
				}
			});
		}
		/*store.dispatch({
			type: 'UPD_AUTH',
			data: 1
		});*/
		//this.props.updateData("AUTH", 1);
	}
	render(){
        console.log("Render login");

		return (
			<div>
	      <div className="login_wrapper">
	        <div className="animate form login_form">
	          <section className="login_content">
	            <form action="" method="post" onSubmit={this.login} ref={(inp) => this.form = inp}>
	              <h1>Administration</h1>
	              <div>
	                <input type="text" ref={(input) => this.mail = input} className="form-control" name="usr" placeholder="Email" required=""/>
	              </div>
	              <div>
	                <input type="password" ref={(input) => this.pass = input} className="form-control" name="psw" placeholder="Kodeord" required=""/>
	              </div>
	              <div>
	                <input className="btn btn-default submit" type="submit" value={this.state.loading ? "Loading.." : "Log ind"}/>
	              </div>

	              <div className="clearfix"></div>
	              <div className="separator">
	                <div className="clearfix"></div>
	                <div>
	                    <img src="/includes/images/SAD_full.png" alt="Safeallday" style={{width: "40%"}} />
	                </div>
	              </div>
	            </form>
	          </section>
	        </div>
	      </div>
	    </div>
			);
	}
}


// WEBPACK FOOTER //
// ./src/components/LoginPage.js